import { cn } from "src/common/utils";

// Glyph from Rollbar's official wordmark in Rollbar brand blue (#3c72ff,
// matching their GitHub org avatar exactly), rendered on the dark navy tile
// (#212631) used as rollbar.com's page background.
const RollbarIcon = ({ className }: { className?: string }) => (
  <div className={cn(className, "bg-[#212631] rounded-sm p-1")}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 210 174.23"
      width="100%"
      height="100%"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M208.75 5.17a5.54 5.54 0 00-.1-1c0-.1-.05-.19-.08-.29s-.13-.45-.21-.67l-.15-.32a4.37 4.37 0 00-.32-.55c-.07-.11-.14-.22-.22-.33l-.14-.19c-.08-.09-.17-.16-.25-.24l-.2-.24-.16-.11a5.07 5.07 0 00-.46-.35l-.39-.25a5.05 5.05 0 00-.53-.24l-.42-.17c-.19-.06-.39-.09-.58-.13l-.43-.09a5.58 5.58 0 00-.71 0h-.4c-2.68.24-38.09 3.62-77.89 21.37-23.9 10.63-42.4 26.95-54.04 46.76l-3 1.3C25.46 88.45 0 125.42 0 168.33v.72a5.19 5.19 0 003 4.7 5.28 5.28 0 002.19.48h141.45a4.54 4.54 0 00.82-.07l.36-.09c.17-.05.34-.08.51-.14s.25-.12.38-.18.3-.12.44-.2a5.63 5.63 0 00.75-.53l57-48.06a5.16 5.16 0 001.84-4V5.17zm-51.54 148.11l-5.47 4.61V55.64l46.64-39.31v102.25zm-93.12-27.11h77.28v37.69h-122zm65.23-95.32a267.23 267.23 0 0156.81-17.77l-41.69 35.15A264.47 264.47 0 0188 61.52c10.32-12.6 24.24-23.05 41.32-30.67zM78.09 76.43a267.64 267.64 0 0163.28-17.35v56.72H67.49a91.66 91.66 0 0110.6-39.37zm-14.23 6.62A102.7 102.7 0 0057 118.56l-46 38.82c3.48-31.54 22.21-57.92 52.86-74.33z"
        fillRule="evenodd"
        fill="#3c72ff"
      />
    </svg>
  </div>
);

export default RollbarIcon;
